import { ChevronDown } from 'lucide-react'
import { Collapsible, CollapsibleContent, CollapsibleTrigger } from '@teach/ui'

export interface FaqItem {
  question: string
  answer: string
}

/** Раскрывающиеся вопросы-ответы: «что важно знать» без стены текста. Общий для гайда MCP и настроек курса. */
export const FaqList = ({ items }: { items: FaqItem[] }) => (
  <ul className="space-y-2">
    {items.map(({ question, answer }) => (
      <li key={question}>
        <Collapsible className="group rounded-2xl bg-foreground/5">
          <CollapsibleTrigger className="flex w-full items-center justify-between gap-3 rounded-2xl px-5 py-4 text-left text-base font-medium outline-none focus-visible:ring-2 focus-visible:ring-ring">
            {question}
            <ChevronDown className="size-4 shrink-0 text-muted-foreground transition-transform group-data-[state=open]:rotate-180" />
          </CollapsibleTrigger>
          <CollapsibleContent>
            <p className="px-5 pb-5 text-base leading-relaxed text-muted-foreground">{answer}</p>
          </CollapsibleContent>
        </Collapsible>
      </li>
    ))}
  </ul>
)
